import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { DetailRequest } from "@/api/shop-category/request";
import { DetailResponse } from "@/api/shop-category/response";
import * as ShopCategoryAPI from "@/api/shop-category";
import { isSuccess } from "@/api/response";

const MODULE_NAME = "shop-category/detail";

/**
 * カテゴリ情報取得API（/search-shop-category）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Detail extends VuexModule {
  // state
  detailResponse: DetailResponse = {} as DetailResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.detailResponse);
  }

  get getMessage() {
    return this.detailResponse.message;
  }

  get getCategoryType() {
    if (this.detailResponse.results) {
      return this.detailResponse.results.categoryType;
    } else {
      return 0;
    }
  }

  // MutationActions
  @MutationAction
  async detail(detailRequest: DetailRequest) {
    const detailResponse = await ShopCategoryAPI.detail(detailRequest);
    return {
      detailResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      detailResponse: {} as DetailResponse
    };
  }
}

export default getModule(Detail);
